import React from 'react';
import {t} from '@lingui/macro';
import {withI18n} from "@lingui/react";
// import {Tag} from 'antd';
import { TooltipWrapper } from './TolltipWrapper';
import BukkuEllipsisTag from '../Tag';

export default withI18n()(props => {
    const {record, hideTooltip, onClick} = props;
    const parsedStatus = record.status || props.status;

    let color, statusText;

    switch (parsedStatus?.toLowerCase()) {
        case 'draft':
            color = 'purple';
            statusText = t`Draft`;
            break;
        case 'pending_approval':
            color = 'blue';
            statusText = t`Pending Approval`;
            break;
        case 'ready':
            color = 'green';
            statusText = t`Ready`;
            break;
        case 'void':
        case 'voided':
            color = '';
            statusText = t`Void`;
            break;
        default: break;
    }

    return (
        <TooltipWrapper title={statusText} hideTooltip={hideTooltip}>
            <BukkuEllipsisTag
                color={color}
                onClick={onClick}
            >
                { statusText }

            </BukkuEllipsisTag>
        </TooltipWrapper>
    );
});
